import { ThemeOptions } from '@mui/material';

export const MuiPopover: ThemeOptions['components']['MuiPopover'] = {
  defaultProps: {},
  styleOverrides: {}
};
